import { useCallback } from "react";
import { useLocalStorage } from "@rehooks/local-storage";

import { getMainNavigationAnnouncementStorageKey } from "../components/announcements/constants";

const useMainNavigationAnnouncement = (announcementId: string) => {
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    getMainNavigationAnnouncementStorageKey(announcementId),
    false
  );

  const dismiss = useCallback(() => setIsDismissed(true), [setIsDismissed]);

  return { isDismissed, dismiss };
};

export default useMainNavigationAnnouncement;
